<template>
  <div id="details">
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h3>{{ date }}</h3>
      </template>
      <template #end>
        <Button
          :label="$t('action.back')"
          class="p-button-secondary p-button-rounded p-button-outlined"
          @click="$router.go(-1)"
        />
      </template>
    </Toolbar>

    <div class="grid">
      <div class="col-12 lg:col-6">
        <div>
          <h4 class="mb-2">
            {{ $t('entity.user.user') }}
          </h4>
          <p class="mt-2">
            {{ $t('entity.user.name') }} : <strong>{{ user.firstname }} {{
              user.lastname
            }}</strong>
          </p>
          <p class="mt-2">
            {{ $t('entity.user.company') }} : <strong>{{ user.stakeholder.name }}</strong>
          </p>
          <p v-if="user.email && user.email !== ''" class="mt-2">
            {{ $t('entity.user.email') }} : <strong>{{ user.email }}</strong>
          </p>
          <p
            v-if="user.phoneNumber"
            class="mt-2"
          >
            {{ $t('entity.user.phoneNumber') }} : <strong>{{ formatPhoneNumberAsInternational(user.phoneNumber, user.phoneNumberCountryCode) }}</strong>
          </p>
        </div>
        <div>
          <h4 class="mb-2">
            {{ $t('entity.user.stakeholderId') }}
          </h4>
          <p class="mt-2">
            {{ $t('entity.stakeholder.stakeholderId') }} : <strong>{{
              user.stakeholder.stakeholderId
            }}</strong>
          </p>
          <p class="mt-2">
            {{ $t('entity.stakeholder.name') }} : <strong>{{ user.stakeholder.name }}</strong>
          </p>
        </div>
      </div>
      <div class="col-12 lg:col-6">
        <div class="p-input mb-3">
          <h4 class="mb-2">
            {{ $t('entity.lineId.mainVenue') }}
          </h4>
          <p class="mt-2">
            <strong>{{ $i18n.locale === 'fr' ? immediateTagging.mainVenue.frenchWording : immediateTagging.mainVenue.englishWording }}</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import {convertDateStringToDayTimeLocaleString} from "@/shared/utils/dateTimeUtils";
import {formatPhoneNumberAsInternational} from "@/shared/utils/phoneNumberUtils";

export default {
  name: 'ImmediateTaggingDetail',
  components: {Toolbar, Button},
  props: {
    immediateTagging: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.immediateTagging.user;
    },
    date() {
      return convertDateStringToDayTimeLocaleString(
        this.immediateTagging.creationDate,
        this.$i18n.locale);
    }
  },
  methods: {formatPhoneNumberAsInternational}
}
</script>

<style scoped lang="scss">
#time {
  text-transform: capitalize;
}

#details {
  border: 2px solid $light-grey;
  padding: 20px;
}
</style>

